import { shippingAddressActions, useAppDispatch, useAppSelector } from '../../../data/store';
import BillingForm from './billing-form';
import ShippingForm from './shipping-form';
import React, { ChangeEvent } from 'react';
import { updateControl } from '../../../../../../domain/validation/validation';

const AddressForm = () => {

    const dispatch = useAppDispatch();
    const cartData = useAppSelector(store => store.root.cartData);
    const isShippingDifferentFromBilling = useAppSelector(store => store.shippingAddress.isShippingDifferentFromBilling);
    const upsShippingCodeControl = useAppSelector(store => store.shippingAddress.upsShippingCodeControl);

    const isShippingDifferentFromBillingHandler = (evt: ChangeEvent) => {
        const $target = evt.target as HTMLInputElement;

        dispatch(
            shippingAddressActions.setIsShippingDifferentFromBilling($target.checked)
        );

        // reset shipping drop-down
        dispatch(
            shippingAddressActions.main({
                upsShippingOptions: [],
                upsShippingError: '',
            })
        );

        dispatch(
            shippingAddressActions.setControl({
                controlName: 'upsShippingCodeControl',
                control: updateControl(upsShippingCodeControl, '', true)
            })
        );
    };

    return (
        <>
            <BillingForm />

            {
                cartData.isShippingNeeded && (
                    <>
                        {
                            <div className="mb-6">
                                <label className="flex items-center">
                                    <input
                                        type="checkbox"
                                        data-qa="cart-step3-ship-diff-cb"
                                        className="mr-3"
                                        checked={ isShippingDifferentFromBilling }
                                        name="isShippingDifferentFromBilling"
                                        onChange={ isShippingDifferentFromBillingHandler }
                                    />
                                    <span className="text-base">Shipping address is different than billing address</span>
                                </label>
                            </div>
                        }

                        { isShippingDifferentFromBilling && <ShippingForm /> }
                    </>
                )
            }
        </>
    )
};

export default AddressForm;